import { Component, Input, OnInit, computed, inject, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs';

import { ButtonIcon } from '@fcom/ui-components/components/buttons/button/interfaces';
import { ButtonTheme } from '@fcom/ui-components/components/buttons/button/enums';
import { ResponsiveImage } from '@fcom/ui-components/components/images/interfaces';

import { AspectRatioString } from '../../interfaces/images.interface';
import { ElementActions, ElementTypes, GaContext } from '../../interfaces/gtm.interface';
import { GtmService } from '../../gtm/services/gtm.service';
import { FragmentService } from '../../services/fragments/fragment.service';
import { MediaQueryService } from '../../services/media-query/media-query.service';

@Component({
  selector: 'fin-promotion-banner',
  templateUrl: './promotion-banner.component.html',
  styleUrls: ['./promotion-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PromotionBannerComponent implements OnInit {
  private gtmService = inject(GtmService);
  private mediaQueryService = inject(MediaQueryService);
  private fragmentService = inject(FragmentService);

  protected readonly ButtonTheme = ButtonTheme;

  @Input()
  image$: Observable<ResponsiveImage>;

  private readonly isMobile = this.mediaQueryService.isBreakpoint('mobile');
  readonly aspectRatio = computed((): AspectRatioString => {
    return this.isMobile() ? '1x1' : '16x9';
  });

  @Input()
  translationPrefix: string;

  @Input()
  url: string;

  @Input()
  imageFromFragment: string;

  @Input()
  buttonIcon: ButtonIcon;

  @Input()
  imagePosition: 'top' | 'left' = 'top';

  @Input() isExternalLink?: boolean;
  loadImageFromFragment = (fragment: string): Observable<ResponsiveImage> =>
    this.fragmentService.getCmsPictureFromFragment(fragment);

  ngOnInit(): void {
    if (this.imageFromFragment) {
      this.image$ = this.loadImageFromFragment(this.imageFromFragment);
    }
  }

  trackPromoBanner(banner: string): void {
    this.gtmService.trackElement(
      `${banner}-promotion-banner`,
      GaContext.BOOKING_FLOW,
      ElementTypes.BANNER,
      banner,
      ElementActions.CLICK
    );
  }
}
